import { adminHttpClient } from '../commons/adminHttpClient'

export interface ServiceProviderResponse {
  name: string
}

export const getServiceProviders = (): Promise<ServiceProviderResponse[]> => {
  return adminHttpClient.get(`Expenses/ServiceProviders`)
}
